/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * NumberFieldIcon component - Icon for number field question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const NumberFieldIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M5 11C4.59 11 4.25 10.66 4.25 10.25C4.25 9.84 4.59 9.5 5 9.5H6.25C6.8 9.5 7.25 9.95 7.25 10.5V14.75C7.25 15.16 6.91 15.5 6.5 15.5C6.09 15.5 5.75 15.16 5.75 14.75V11H5ZM10 9.5C9.59 9.5 9.25 9.84 9.25 10.25C9.25 10.66 9.59 11 10 11H12.25V12H10.25C9.7 12 9.25 12.45 9.25 13V14.5C9.25 15.05 9.7 15.5 10.25 15.5H13C13.41 15.5 13.75 15.16 13.75 14.75C13.75 14.34 13.41 14 13 14H10.75V13H12.75C13.3 13 13.75 12.55 13.75 12V10.5C13.75 9.95 13.3 9.5 12.75 9.5H10ZM18.75 15.5C19.3 15.5 19.75 15.05 19.75 14.5V10.5C19.75 9.95 19.3 9.5 18.75 9.5H16C15.59 9.5 15.25 9.84 15.25 10.25C15.25 10.66 15.59 11 16 11H18.25V12H16.75C16.47 12 16.25 12.22 16.25 12.5C16.25 12.78 16.47 13 16.75 13H18.25V14H16C15.59 14 15.25 14.34 15.25 14.75C15.25 15.16 15.59 15.5 16 15.5H18.75Z'
        fill={color}
      />
    </svg>
  )
}

export default NumberFieldIcon
